import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { Text } from "@/components/ui/text";
import { View } from "react-native";

import { TEST_IDS } from "@/testIdDefinition";
import { formatFileSize, iconForAttachment, type AttachmentFile } from "./attachmentUtils";

type AttachmentFileListProps = {
  files: AttachmentFile[];
  onRemove?: (id: string) => void;
  onOpen?: (id: string) => void;
  busyId?: string | null;
};

export function AttachmentFileList({
  files,
  onRemove,
  onOpen,
  busyId = null,
}: AttachmentFileListProps) {
  if (files.length === 0) {
    return null;
  }

  return (
    <View className="gap-2">
      {files.map((file) => {
        const isBusy = busyId === file.id;

        return (
          <View
            key={file.id}
            className="flex-row items-center gap-3 rounded-md border border-border bg-card px-3 py-2"
          >
            <Icon
              name={iconForAttachment(file.mimeType, file.name)}
              className="text-muted-foreground"
              size={16}
            />
            <View className="min-w-0 flex-1">
              <Text
                variant="small"
                numberOfLines={1}
                testID={TEST_IDS[TEST_IDS.ATTACHMENT_ROW_NAME]}
              >
                {file.name}
              </Text>
              <Text variant="caption">{formatFileSize(file.size)}</Text>
            </View>
            {onOpen ? (
              <Button
                variant="ghost"
                size="icon"
                disabled={isBusy}
                accessibilityLabel={`Open ${file.name}`}
                onPress={() => onOpen(file.id)}
                testID={TEST_IDS[TEST_IDS.ATTACHMENT_ROW_OPEN_BUTTON]}
              >
                <Icon
                  name="download"
                  className="text-muted-foreground"
                  size={14}
                />
              </Button>
            ) : null}
            {onRemove ? (
              <Button
                variant="ghost"
                size="icon"
                disabled={isBusy}
                accessibilityLabel={`Remove ${file.name}`}
                onPress={() => onRemove(file.id)}
                testID={TEST_IDS[TEST_IDS.ATTACHMENT_ROW_REMOVE_BUTTON]}
              >
                <Icon name="xmark" className="text-muted-foreground" size={14} />
              </Button>
            ) : null}
          </View>
        );
      })}
    </View>
  );
}
